module.exports = __webpack_public_path__ + "img/fondo-login.a907433f.png";